import {raise} from '@yandex-delivery/utils'
import {TariffListResponse} from '@yandex-delivery/api/repo/tariffs'

export function validateTariffs(tariff?: string) {
  return function _validateTariffs(response: TariffListResponse) {
    if (tariff && !response.tariffs.some(({id}) => tariff === id)) {
      raise(`Wrong tariff: ${tariff}`)
    }

    return response
  }
}
